import React from "react";
import PropTypes from "prop-types";
import { Route, withRouter } from "react-router-dom";

const PrivateRoute = ({
  component: Component,
  path,
  location,
  elementParams,
  ...rest
}) => {

  return (
    <Route
      path={path}
      render={(props) => <Component {...props} {...elementParams} />}
      {...rest}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};

export default withRouter(PrivateRoute);
